import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"vertical-alignment-center"} maskId="square-filled-radius-0-stroke-1-IconVerticalAlignmentCenter"><path d="M12.5 3H11.5V6H4V11H11.5V13H6V18H11.5V21H12.5V18H18V13H12.5V11H20V6H12.5V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVerticalAlignmentCenter;
